// extracted by mini-css-extract-plugin
export var buttonWrapper = "MobileDetailProduct_buttonWrapper__TwWqN";
export var container = "MobileDetailProduct_container__g84mQ";
export var icon = "MobileDetailProduct_icon__e9CIC fa fa-chevron-left";